import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';

import EditorRepeatingPanel from './ssEditorRepeatingPanel';
import RuntimeRepeatingPanel from './ssRuntimeRepeatingPanel';
import ControlChangesIcon from '../../components/ControlChangesIcon';
import { FCM_CONTAINER_STYLES } from '../../constants/runtime.constants';

const useStyles = makeStyles(FCM_CONTAINER_STYLES);

const SSRepeatingPanel = ({
  isEditor,
  isControlHiddenFCM,
  isControlAddedFCM,
  isControlChangedFCM,
  ...props
}) => {
  const classes = useStyles({ isControlAddedFCM });

  if (isEditor) {
    return <EditorRepeatingPanel {...props} />;
  }

  if (isControlAddedFCM || isControlChangedFCM) {
    return (
      <div className={classes.changesModeWrapper} data-ss-id={props.id}>
        <div
          className={classNames(classes.control, isControlHiddenFCM ? classes.hiddenControl : '')}
          data-hidden-fcm={isControlHiddenFCM}
        >
          <RuntimeRepeatingPanel {...props} />
        </div>
        {isControlChangedFCM && (
          <div className={classes.changesIcon}>
            <ControlChangesIcon id={props.id} />
          </div>
        )}
      </div>
    );
  }

  if (isControlHiddenFCM) {
    return (
      <div className={classes.hiddenControl} data-hidden-fcm="true" data-ss-id={props.id}>
        <RuntimeRepeatingPanel {...props} />
      </div>
    );
  }

  return (
    <div data-ss-id={props.id}>
      <RuntimeRepeatingPanel {...props} />
    </div>
  );
};

export default SSRepeatingPanel;
